import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();
  if (!token) {
    // เก็บหน้าที่ตั้งใจจะเข้าไว้ใน state เพื่อพากลับมาหลัง Login สำเร็จ (เช่น deeplink จาก push notification)
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;